import {Injectable} from '@angular/core';
import {PostLoginLoanApplicationFlowStep} from './post-login-loan-application-flow.step';
import {UserInteractor} from '../../interactors/user.interactor';
import {LoanApplicationInteractor} from '../../interactors/loan-application.interactor';
import {UserAddressInteractor} from '../../interactors/user-address.interactor';
import {isNil} from 'lodash';

@Injectable()
export class ResidenceProofStep extends PostLoginLoanApplicationFlowStep {
    constructor(userInteractor: UserInteractor, private loanApplicationInteractor: LoanApplicationInteractor, private userAddressInterator: UserAddressInteractor) {
        super(userInteractor);
    }

    description(): string {
        return 'To stay connected through a verified address';
    }

    displayName(): string {
        return 'Proof of Residence';
    }

    async isStepComplete(): Promise<boolean> {
        const loanApplication = await this.loanApplicationInteractor.get();

        //TODO Partially remove this when application progress resumption flow is completed.
        if (isNil(loanApplication) || isNil(loanApplication.addressId)) {
            return false;
        }

        const address = await this.userAddressInterator.get(loanApplication.addressId);
        return !isNil(address) && !isNil(address.proofs);
    }

    url(): string {
        return this.createBorrowerFlowUrl('residence-proof');
    }
}
